export default __webpack_public_path__ + "static/media/e6.3d0119ba.webp";